import type { MubinsoFaq } from "@/utils/buildMubinsoPageProps";

interface MubinsoFAQProps {
  faqs: MubinsoFaq[];
  title?: string;
}

/**
 * 아코디언은 details/summary 로 만든다. JS 없이 동작하고, 접혀 있어도 답변이
 * DOM 에 그대로 있어 크롤러가 읽는다(FAQPage 스키마와 본문이 어긋나지 않는다).
 */
export const MubinsoFAQ = ({
  faqs,
  title = "자주 묻는 질문",
}: MubinsoFAQProps) => {
  return (
    <section className="mb-faq" aria-labelledby="mb-faq-title">
      <h2 id="mb-faq-title" className="mb-faq__title">
        {title}
      </h2>
      <div className="mb-faq__list">
        {faqs.map((faq, index) => (
          <details key={faq.q} className="mb-faq__item" open={index === 0}>
            <summary className="mb-faq__q">
              <span>{`Q. ${faq.q}`}</span>
              <span className="mb-faq__mark" aria-hidden="true" />
            </summary>
            <p className="mb-faq__a">{faq.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
};
